<template>
  <div class="row">
    <div class="col">
      <div>
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-dollar-sign" />
            </button>
              <h4>{{ $t('financial') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in financial" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  financial,
} from '@/config/settings'

export default {
  name: 'TestSettingsList',
  data: () => ({
    financial: financial(),
  })
}
</script>
